import React, { useEffect, useState } from "react";
import { useAuth } from "../../../../firebase/AuthProvider";
import { getInterimTemplates } from "../../../../services/taskServices/TaskService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import InterimTemplateResponse from "../../../../interfaces/task/InterimTemplateResponse";
import { Link, useNavigate } from "react-router-dom";
import EditTemplateInterimTask from "./EditTemplateInterimTask";
import { Button } from "react-bootstrap";
import editicons from '../../../../assets/images/editicons.svg';
import backarrowbtn from '../../../../assets/images/backarrowbtn.svg';

const EditTemplateInterimTasks = () => {
  const { currentUser, currentRoles } = useAuth();
  const navigate = useNavigate();

  const [templates, setTemplates] = useState<InterimTemplateResponse[]>([]);
  const [selectedTemplate, setSelectedTemplate] =
    useState<InterimTemplateResponse>();
  const [reload, setReload] = useState<boolean>(false);

  useEffect(() => {
    const fetchTemplates = async () => {
      if (currentUser !== null) {
        const authToken = await currentUser.getIdToken();
        const response = await getInterimTemplates(authToken);
        if (response) setTemplates(response);
      }
    };

    fetchTemplates();
  }, [currentUser, reload]);

  const selectTemplate = (template: InterimTemplateResponse) => {
    if (!template) {
      setReload(!reload);
    }
    setSelectedTemplate(template);
  };

    const backBtnUrl = (): string => {
        if (currentRoles?.some((role) => role.name === "OWNER" || role.name === "ADMIN")) {
            return "/dashboard/owner/settings";
        } else {
            return "/settings";
        }
    }
  return (
    <>
      <div className="">

        <div className="">
          {selectedTemplate ? (
            <div className="new_activity_container">
              <EditTemplateInterimTask
                setSelectedTemplate={setSelectedTemplate}
                template={selectedTemplate}
              />
            </div>
          ) : (
            <div className="common_card">
              <div className="top top_bar_flx">
                <div className="top_bar_tittle">
                  <h2>
                   <Link to={backBtnUrl()}><img style={{width: '1.5rem'}} src={backarrowbtn} alt="backarrowbtn" /></Link>
                    Edit Interim Template</h2>
                </div>
                <div className="top_right_flx">
                  <Button variant="primary" className="btn_sm" onClick={() => navigate("/addtask/new/interim/template/")}>Add New</Button>
                </div>
              </div>

              <div className="task_activity_options_grid">
                {templates &&
                  templates.map((template, index) => (
                    <div key={index} className="task_activity_options_card template_file_card">
                      <div className="task_activity_options_card_txt">
                        <h3>{template.title}</h3>
                      </div>
                      <button className="flex-shrink-0" onClick={() => selectTemplate(template)}>
                        <img style={{ width: '1.5rem' }} src={editicons} alt="editicons" />
                      </button>
                    </div>
                  ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default EditTemplateInterimTasks;
